import React, { useEffect, useState } from 'react';
import notesService from '../../services/notesService';
import { Link } from 'react-router-dom';

// Accept optional props from Dashboard to avoid duplicate fetches
const NotesLists = ({ recentNotes: initialRecentNotes = null, loading: parentLoading = false }) => {
  const [notes, setNotes] = useState(initialRecentNotes || []);
  const [loading, setLoading] = useState(parentLoading || (!initialRecentNotes));
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    // If dashboard provided recent notes, use them
    if (initialRecentNotes) {
      setNotes(initialRecentNotes);
      setLoading(false);
      return () => { mounted = false; };
    }

    const fetchRecent = async () => {
      try {
        const res = await notesService.getAllNotes({ page: 1, limit: 5, sort: '-createdAt' });
        if (mounted) setNotes(res?.data?.notes || []);
      } catch (err) {
        if (mounted) setError('Failed to load recent notes');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchRecent();
    return () => { mounted = false; };
  }, [initialRecentNotes]);

  if (loading) return <div className="text-sm text-gray-500">Loading recent notes…</div>;
  if (error) return <div className="text-sm text-red-500">{error}</div>;

  return (
    <div className="space-y-3">
      {notes.length === 0 && (
        <div className="flex items-center justify-between text-sm text-gray-500">
          <span>No recent notes.</span>
          <Link to="/notes" className="text-blue-600 hover:underline">Create a note</Link>
        </div>
      )}
      {notes.map(note => (
        <div key={note._id} className="p-3 border rounded flex items-start justify-between">
          <div>
            <Link to={`/notes/${note._id}`} className="font-semibold text-gray-900 dark:text-white">{note.title || 'Untitled'}</Link>
            <div className="text-xs text-gray-500">{new Date(note.createdAt).toLocaleString()}</div>
          </div>
          <div className="text-sm text-gray-500">{(note.tags || []).slice(0,2).join(', ')}</div>
        </div>
      ))}
    </div>
  );
};

export default NotesLists;